import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ClonesService = {
    list: async (data) => axios.post(API_URL + "/clones/list", data).then(({data}) => data).catch((err) => { throw err }),
    markVerified: async (data) => axios.post(API_URL + "/clones/markVerified", data).then(({data}) => data).catch((err) => { throw err }),
    createOccurrence: async (data) => axios.post(API_URL + "/clones/createOccurrence", data).then(({data}) => data).catch((err) => { throw err }),
    openPassage: async (data) => axios.post(API_URL + "/clones/openPassage", data).then(({data}) => data).catch((err) => { throw err }),
    openAssociated: async (data) => axios.post(API_URL + "/occurrence/openAssociatedOccurrencesSentryView", data).then(({data}) => data).catch((err) => { throw err }),
    searchNotificationById: async (data) => axios.post(API_URL + "/cloneInfo/apply", data).then(({data}) => data).catch((err) => { throw err }),
}

export default ClonesService;